import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieConsent from "./CookieConsent";
import { Toaster } from "@/components/ui/sonner";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return (
    <div className="App min-h-screen flex flex-col bg-bone text-ink">
      <Header />
      <main className="flex-1 pt-[72px]" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
      <Toaster position="bottom-right" />
    </div>
  );
}
